<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 14:18:05
-->
<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="用户电话">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userTel"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.orderNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">订单状态</span>
          <el-select
            v-model="queryParam.orderState"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="待付款" value="1"></el-option>
            <el-option label="待发货" value="2"></el-option>
            <el-option label="待收货" value="3"></el-option>
            <el-option label="已完成" value="9"></el-option>
            <el-option label="已取消" value="10"></el-option>
            <el-option label="已退款" value="11"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">创建时间</span>
          <el-date-picker
            size="mini"
            v-model="createDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <div class="selectBox">
          <span class="selectText">支付时间</span>
          <el-date-picker
            size="mini"
            v-model="payDate"
            @change="payDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-popconfirm title="确定退款吗？" @confirm="chareBack()">
            <template #reference>
              <el-button size="mini" type="danger">退款</el-button>
            </template>
          </el-popconfirm>
          <el-popconfirm
            style="margin-left: 10px"
            title="请确认订单状态，此操作不可逆"
            @confirm="debounceSearch"
          >
            <template #reference>
              <el-button size="mini" type="primary">订单完成</el-button>
            </template>
          </el-popconfirm>
          <!-- <el-button
            style="margin-left: 10px"
            type="primary"
            @click="handleExportXls('订单列表', url.exportXlsUrl)"
            >导出订单列表</el-button
          > -->
          <div class="exportSelectBox">
            <el-select value="更多" size="mini" @change="selectExport">
              <el-option
                value="/mallOrder/exportMallOrder"
                label="订单列表导出"
              ></el-option>
              <el-option
                value="/mallOrder/exportPaidMallOrder"
                label="已支付订单导出"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
      :expand="true"
      @expandChange="onExpandChange"
    >
      <template #expand="slotData">
        <div class="demo-table-expand">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item
              v-for="item in slotData.data.row.mallOrderItemDTOList"
              :key="item.id"
              :title="item.productName"
              :name="item.id + ''"
            >
              <el-descriptions :column="3" border>
                <el-descriptions-item
                  labelStyle="width: 100px"
                  contentStyle="width: 300px"
                >
                  <template slot="label"> 商品名称 </template>
                  <span>{{ item.productName }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 商品数量 </template>{{ item.num }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 商品图片 </template>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.productImage"
                  >
                  </el-image>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 商品支付价格 </template>
                  <span>{{ item.productPayPrice }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 商品价格 </template>
                  <span>{{ item.productPrice }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 商品总价 </template>
                  <span>{{ item.productTotalPrice }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 快递公司 </template>
                  {{ item.expressCompany || "--" }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 快递单号 </template>
                  {{ item.expressNo || "--" }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> 快递状态 </template>
                  {{ expressStateCode[item.expressState || "1"] }}
                </el-descriptions-item>
              </el-descriptions>
              <el-button size="mini" @click="handleEdit(item)"
                >录入快递信息</el-button
              >
            </el-collapse-item>
          </el-collapse>
        </div>
      </template>
      <template #orderType="slotData">
        <p v-if="slotData.data.row.orderType == 1">商品订单</p>
      </template>
      <template #payType="slotData">
        <p v-if="slotData.data.row.payType == 1">环保金支付</p>
        <p v-if="slotData.data.row.payType == 2">微信支付</p>
        <p v-if="slotData.data.row.payType == 3">组合支付</p>
      </template>
      <template #orderState="slotData">
        <p v-if="slotData.data.row.orderState == 1">待付款</p>
        <p v-if="slotData.data.row.orderState == 2">待发货</p>
        <p v-if="slotData.data.row.orderState == 3">待收货</p>
        <p v-if="slotData.data.row.orderState == 9">已完成</p>
        <p v-if="slotData.data.row.orderState == 10">已取消</p>
        <p v-if="slotData.data.row.orderState == 11">已退款</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row)"
          >详情</el-button
        >
      </template>
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
    <editForm ref="editForm" @editOk="editOk"></editForm>

    <el-dialog
      title="退款"
      :visible.sync="dialogFormVisible"
      @close="chareBackCancel()"
    >
      <el-form :model="form">
        <el-form-item label="环保金退款金额">
          <el-input
            v-model="form.refundEpgAmount"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信退款金额">
          <el-input
            v-model="form.refundOtherAmount"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chareBackCancel()">取 消</el-button>
        <el-button type="primary" @click="chareBackSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import modalForm from "./component/infoModal.vue";
import editForm from "./component/editModal.vue";
import { debounce } from "lodash";
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, modalForm, editForm },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      createDate: "",
      payDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      deleteKey: "userId",
      url: {
        list: "/mallOrder/queryPage",
        orderDone: "/mallOrder/orderDone",
        exportXlsUrl: "/mallOrder/exportMallOrder",
      },
      //字段权限
      columns: [
        { field: "orderNo", label: "订单号", width: 150 },
        {
          field: "orderState",
          label: "订单状态",
          width: 100,
          slotName: "orderState",
          columnType: "slot",
        },
        {
          field: "totalPrice",
          label: "订单总价",
        },
        {
          field: "payPrice",
          label: "实际支付金额",
        },
        {
          field: "payType",
          label: "支付方式",
          width: 100,
          slotName: "payType",
          columnType: "slot",
        },
        {
          field: "payTime",
          label: "支付时间",
        },
        {
          field: "createTime",
          label: "订单创建时间",
        },
        {
          field: "nickname",
          label: "下单人",
        },
        {
          field: "phone",
          label: "下单人电话",
        },
        {
          field: "userName",
          label: "用户姓名",
        },
        {
          field: "userTel",
          label: "用户电话",
        },
        {
          field: "userAddress",
          label: "用户地址",
        },
        {
          field: "remark",
          label: "备注",
        },

        {
          width: 160,
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      activeName: "0",
      expressStateCode: {
        1: "待发货",
        2: "已发货",
        3: "运输中",
        4: "已签收",
        5: "已拒收",
      },
      dialogFormVisible: false,
      form: { refundEpgAmount: "", refundOtherAmount: "" },
    };
  },
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  watch: {},
  computed: {},
  methods: {
    selectExport(e) {
      if (
        !this.queryParam.payTimeStartTime &&
        !this.queryParam.payTimeEndTime &&
        e === "/mallOrder/exportMallOrder"
      )
        return this.$message.warning("请选择支付日期后导出");
      let newName = "";
      if (e === "/mallOrder/exportMallOrder") newName = "订单列表导出";
      if (e === "/mallOrder/exportPaidMallOrder") newName = "已支付订单导出";
      this.handleExportXls(newName, e);
    },
    searchReset() {
      this.queryParam = {};
      this.createDate = "";
      this.payDate = "";
      this.loadData(1);
    },
    chareBack() {
      if (this.selectedRowKeys.length === 0)
        return this.$message.warning("请选择要退款的订单");
      if (this.selectedRowKeys.length > 1)
        return this.$message.warning("一次仅支持退款一单");
      this.dialogFormVisible = true;
    },
    chareBackCancel() {
      this.dialogFormVisible = false;
      this.form = { refundEpgAmount: "", refundOtherAmount: "" };
    },
    chareBackSubmit() {
      let maxMoney = this.dataSource.find(
        (item) => item.id === this.selectedRowKeys[0]
      );
      let { refundEpgAmount, refundOtherAmount } = this.form;
      if (maxMoney.orderState === 1)
        return this.$message.warning("该订单未支付，无法退款");
      if (!refundEpgAmount)
        return this.$message.warning("请填写环保金退款金额");
      if (!refundOtherAmount)
        return this.$message.warning("微信退款金额最少填写为0");
      if (refundEpgAmount > maxMoney.epgPaymentAmount)
        return this.$message.warning("环保金退款金额不能大于实际支付金额");
      if (refundOtherAmount > maxMoney.otherPaymentAmount)
        return this.$message.warning("微信退款金额不能大于实际支付金额");
      httpAction(
        "/mallOrder/orderRefund",
        { id: this.selectedRowKeys[0], refundEpgAmount, refundOtherAmount },
        "post"
      ).then((res) => {
        if (res.code !== 200 && res.data !== true)
          return this.$message.warning(res.data.msg);
        this.$message.success("退款成功");
        this.chareBackCancel();
        this.loadData();
      });
    },
    payDateChange(date) {
      if (date) {
        this.queryParam.payTimeStartTime = date[0] + " 00:00:00";
        this.queryParam.payTimeEndTime = date[1] + " 23:59:59";
      } else {
        this.queryParam.payTimeStartTime = "";
        this.queryParam.payTimeEndTime = "";
      }
    },
    dateChange(date) {
      if (date) {
        this.queryParam.createOrderStartTime = date[0] + " 00:00:00";
        this.queryParam.createOrderEndTime = date[1] + " 23:59:59";
      } else {
        this.queryParam.createOrderStartTime = "";
        this.queryParam.createOrderEndTime = "";
      }
    },
    editOk() {
      this.loadData(1);
    },
    onExpandChange(row) {
      console.log(row);
    },
    handleEdit: function (record) {
      this.$refs.editForm.edit(record);
      this.$refs.editForm.title = "编辑";
      this.$refs.editForm.disableSubmit = false;
    },
    debounceSearch: debounce(function () {
      if (!this.selectedRowKeys.length)
        return this.$message.warning("请选择订单后点击");
      this.complete();
    }, 500),
    async complete() {
      let res = await httpAction(
        this.url.orderDone,
        this.selectedRowKeys,
        "post"
      );
      if (res.code == 200) {
        this.$message.success("操作成功");
        this.loadData(1);
      } else {
        this.$message.warning(res.msg);
      }
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>
<style lang="less" scoped>
.wrapper {
}
::v-deep.el-descriptions__header {
  display: none;
}
.demo-table-expand {
  width: 90%;
  margin-left: 60px;
  // display: flex;
  // div {
  //   margin-right: 100px;
  // }
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
.exportSelectBox {
  display: inline-block;
  margin-left: 10px;
  /deep/.el-input input {
    background: #409eff;
    color: white;
    width: 70px;
    height: 28px;
  }
}
</style>
